import cx from 'classnames';
import styles from '../../styles/rent.scss';
import {
  SaveTaxesCard,
  RentReceiptInfo,
  TreeBackground,
} from '../rent/staticComponents';
import RentForm from '../rent/RentForm';

export const MainFormDiv = (props: any) => (
  <div className={cx(styles['content-wrapper'])}>
    <div className={cx(styles['rentreceipt'])}>
      <RentReceiptInfo />
      <RentForm
        getReceipt={props.receiptAppear}
        getReceiptData={props.getReceiptData}
      />
      <SaveTaxesCard />
      <TreeBackground />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/rent/MainFromDiv.tsx